import {NgModule} from '@angular/core';
import {CmsConfig, I18nConfig, provideConfig} from '@spartacus/core';
import {
  organizationTranslationChunksConfig,
  organizationTranslationsDe,
  organizationTranslationsEn,
} from '@spartacus/organization/administration/assets';
import {
  AdministrationRootModule,
  ORGANIZATION_ADMINISTRATION_FEATURE,
} from '@spartacus/organization/administration/root';

@NgModule({
  declarations: [],
  imports: [AdministrationRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [ORGANIZATION_ADMINISTRATION_FEATURE]: {
          module: () => import('@spartacus/organization/administration').then((m) => m.AdministrationModule),
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {en: organizationTranslationsEn, de: organizationTranslationsDe},
        chunks: organizationTranslationChunksConfig,
      },
    } as I18nConfig),
  ],
})
export class OrganizationAdministrationFeatureModule {}
